import {BusinessTypeBaseView} from "./BusinessTypeBaseView";

/**
 * Management view for all BusinessType entities (RFP=1, Partner=2, PartnerLink=3).
 * Mirrors backend BusinessTypeManagementView.java.
 *
 * buyingGuidePage: Unified field for BUYINGGUIDE column (mapped from different
 * field names per type: isBuyingGuidePage for RFP, resource for Partner).
 */
export class BusinessTypeManagementView extends BusinessTypeBaseView {
    parentType: BusinessTypeParentView | null;
    treeSortKey: number;
    /** Buying guide page URL - unified from type-specific fields (see class doc) */
    buyingGuidePage: string | null;
    category: CategoryView | null;
    templateId: number | null;
    actionClass: string | null;

    constructor(data?: any) {
        super(data);
        this.parentType = data?.parentType ? new BusinessTypeParentView(data.parentType) : null;
        this.treeSortKey = data?.treeSortKey ?? 0;
        this.buyingGuidePage = data?.buyingGuidePage ?? null;
        this.category = data?.category ?? null;
        this.templateId = data?.templateId ?? null;
        this.actionClass = data?.actionClass ?? null;
    }
}

/** Parent view - includes grandparent for depth calculation. */
export class BusinessTypeParentView extends BusinessTypeBaseView {
    parentType: BusinessTypeGrandParentView | null;

    constructor(data?: any) {
        super(data);
        this.parentType = data?.parentType ? new BusinessTypeGrandParentView(data.parentType) : null;
    }
}

/** Grandparent view - stops recursion. */
export class BusinessTypeGrandParentView extends BusinessTypeBaseView {
    constructor(data?: any) {
        super(data);
    }
}

/** Category view for Partner types (now uses translatedName like CategoryBaseView). */
export interface CategoryView {
    id: number;
    status: number;
    managerId: number;
    translatedName: {
        id: number;
        name: string;
        nl: string;
        fr: string;
        en: string;
    } | null;
}
